import React, { useState } from 'react'
import useCart from '../../hooks/useCart'
import useTheme from '../../hooks/theme'
import { onAddToCart } from '../utils/analytics'
import { getZaBuyLink } from '../utils/zaProductLinks'
import { Button } from './styles'
import UpsellDialog, { hasUpsell } from '../product/upsell-dialog'

const AddToCart = ({ items, index, locale, slug }) => {
	const newItems = { ...items, index: index }

	const [value, setValue] = useState(newItems)
	const [promoModel, setPromoModel] = useState(null)

	const { addToCart } = useCart()
	const { openCart } = useTheme()

	const {
		imagesCollection: { items: itemImage },
	} = value
	const item = {
		img: itemImage[0].url,
		slug: value.slug,
		name: value.seoTitle,
		sku: value.sku,
		brand: value.brand,
		category: [value.categories && value.categories.title].toString(),
		price: Number(value.price * 100),
		quantity: value.val,
		shippingClass: value.shippingClass,
	}

	const isZaEnquireShop =
		locale === 'en-ZA' &&
		(slug === 'ecoswim/shop' ||
			slug === 'mineral-swim/shop' ||
			slug === 'mineral-swim/shop/v2' ||
			value.brand === 'EcoSwim' ||
			value.brand === 'Mineral Swim' ||
			value.series === 'Eco Swim' ||
			value.series === 'Mineral Swim')

	const addItemToCart = () => {
		addToCart(item)
		onAddToCart(item, 'Category List')
		openCart()
	}

	const handleClick = () => {
		if (locale === 'en-ZA') {
			if (isZaEnquireShop) {
				window.location.href = 'https://www.maytronics.com.au/support/contact/'
				return
			}
			window.location.href = getZaBuyLink(item.slug)
			return
		}
		if (hasUpsell(value.model)) {
			setPromoModel(value.model)
			return
		}
		addItemToCart()
	}

	return (
		<>
			<Button
				onClick={handleClick}
				onKeyDown={handleClick}
				disabled={value.val < 1}
			>
				{locale === 'en-ZA'
					? isZaEnquireShop
						? 'Enquire Now'
						: 'Buy Now'
					: 'Add to cart'}
			</Button>
			<UpsellDialog
				model={promoModel}
				open={promoModel !== null}
				onClose={() => setPromoModel(null)}
				onContinue={() => {
					addItemToCart()
					setPromoModel(null)
				}}
			/>
		</>
	)
}

export default AddToCart